import SocketEvent from "./abstract/SocketEvent"
import {
    GetPatientDataBaselineSpecification,
    GetPatientDataCurrentSpecification,
    GetPatientOverviewSeveritiesSpecification,
    OnValueArrivedEventKey,
    OnValueArrivedEventResponsePayload
} from "pokal_api"
import { showNotification } from "../redux/Notification"
import { dispatchThunk } from "../redux/thunk/thunkify"

const OnValueTypeArrivedEvent: SocketEvent<OnValueArrivedEventResponsePayload> =
    new SocketEvent(OnValueArrivedEventKey, (args, input, dispatch) => {
        showNotification(
            dispatch,
            "Neue Daten",
            `${args.patientName} hat soeben neue Werte hochgeladen.`
        )
        if (input.currentlySelectedPatient !== args.patient) return
        if (input.currentlySelectedValueType === null) return
        dispatchThunk(dispatch, GetPatientOverviewSeveritiesSpecification, {
            patient: args.patient
        })
        dispatchThunk(dispatch, GetPatientDataCurrentSpecification, {
            patient: args.patient,
            valueType: input.currentlySelectedValueType
        })
        dispatchThunk(dispatch, GetPatientDataBaselineSpecification, {
            patient: args.patient,
            valueType: input.currentlySelectedValueType
        })
    })

export default OnValueTypeArrivedEvent
